import React, { useState, useEffect } from 'react';

export const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      zIndex: 10000,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

const Toast = ({ message, type = 'success', onClose }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(onClose, 300);
    }, 10000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getColors = () => {
    switch (type) {
      case 'success':
        return {
          background: 'linear-gradient(135deg, var(--pink) 0%, var(--violet) 100%)',
          shadow: 'rgba(216, 134, 255, 0.4)',
          icon: '✓'
        };
      case 'error':
        return {
          background: 'linear-gradient(135deg, #ff6b6b 0%, #fa5252 100%)',
          shadow: 'rgba(255, 107, 107, 0.4)',
          icon: '✗'
        };
      case 'info':
        return {
          background: 'linear-gradient(135deg, var(--pink) 0%, var(--violet) 100%)',
          shadow: 'rgba(216, 134, 255, 0.4)',
          icon: 'ℹ'
        };
      default:
        return {
          background: 'linear-gradient(135deg, #339af0 0%, #1c7ed6 100%)',
          shadow: 'rgba(51, 154, 240, 0.4)',
          icon: 'ℹ'
        };
    }
  };

  const colors = getColors();

  return (
    <div
      style={{
        background: colors.background,
        color: '#fff',
        padding: '16px 20px',
        borderRadius: '12px',
        boxShadow: `0 4px 20px ${colors.shadow}`,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        minWidth: '300px',
        maxWidth: '500px',
        animation: isExiting ? 'slideOut 0.3s ease forwards' : 'slideIn 0.3s ease',
        fontWeight: '500',
        fontSize: '15px',
        cursor: 'pointer'
      }}
      onClick={() => {
        setIsExiting(true);
        setTimeout(onClose, 300);
      }}
    >
      <div style={{
        fontSize: '20px',
        fontWeight: 'bold',
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}>
        {colors.icon}
      </div>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsExiting(true);
          setTimeout(onClose, 300);
        }}
        style={{
          background: 'rgba(255, 255, 255, 0.2)',
          border: 'none',
          color: '#fff',
          fontSize: '20px',
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          lineHeight: 1,
          transition: 'background 0.2s ease',
          flexShrink: 0
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.2)';
        }}
      >
        ×
      </button>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(400px);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          @keyframes slideOut {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(400px);
              opacity: 0;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Toast;
